import mushroom from "cem-primary-api";
import { Filter, Project } from "mushroomjs";
import toastr from "toastr";
import i18n from "../../i18n";
const t = (key) => i18n.global.t(key);

export const fetchThreshUserCategoryData = async () => {
  mushroom.info_config_thresh_user_category.invalidCache();
  const { result } =
    await mushroom.info_config_thresh_user_category.getAllAsync({
      fields: Project.include(
        "type",
        "group",
        "name",
        "thresh_lower",
        "thresh_higher",
        "value_type",
        "unit",
        "description",
        "enable",
        "weight",
        "min_weight",
        "max_weight",
      ).build(),
    });
  return result;
};

export const fetchTypeWeightSummaryAsync = async () => {
  mushroom.info_config_thresh_user_category.invalidCache();
  const { result } =
    await mushroom.info_config_thresh_user_category.views.getTypeWeightSummaryAsync();
  return result;
};

export const updateTypeWeightSummaryAsync = async (
  info_config_thresh_user_category_object,
) => {
  try {
    const { result } =
      await mushroom.info_config_thresh_user_category.partialUpdateAsync(
        info_config_thresh_user_category_object,
      );
    return result;
  } catch (error) {
    toastr.error(t("toastr_error"));
    throw error;
  }
};

export const resetTypeWeightSummaryAsync = async (idClickhouse) => {
  console.log("idClickhouse", idClickhouse);
  try {
    const { result } =
      await mushroom.info_config_thresh_user_category.resetToDefaultAsync({
        body: {
          id: idClickhouse,
        },
      });
    return result;
  } catch (e) {
    if (e?.code === 400 && e?.subCode === 1000) {
      toastr.error(t("reset_info_config_click_house_error_id"));
      e.handled = true;
    } else if (e?.code === 400 && e?.subCode === 1001) {
      toastr.error(
        t("reset_info_config_click_house_error_not_setting_default"),
      );
      e.handled = true;
    } else if (e?.code === 404 && e?.subCode === 1200) {
      toastr.error(t("reset_info_config_click_house_error_record"));
      e.handled = true;
    }
    throw e;
  }
};

export const fetchInfoConfigUserCategoryAsync = async () => {
  mushroom.info_config_user_category.invalidCache();
  const { result } = await mushroom.info_config_user_category.getAllAsync();
  return result;
};

export const updateInfoConfigUserCategoryAsync = async (
  info_config_user_category_object,
) => {
  try {
    const { result } =
      await mushroom.info_config_user_category.partialUpdateAsync(
        info_config_user_category_object,
      );
    return result;
  } catch (error) {
    toastr.error(t("toastr_error"));
    throw error;
  }
};

export const resetInfoConfigUserCategoryAsync = async (idClickhouse) => {
  try {
    const { result } =
      await mushroom.info_config_user_category.resetToDefaultAsync({
        body: {
          id: idClickhouse,
        },
      });
    return result;
  } catch (e) {
    if (e?.code === 400 && e?.subCode === 1000) {
      toastr.error(t("reset_info_config_click_house_error_id"));
      e.handled = true;
    } else if (e?.code === 400 && e?.subCode === 1001) {
      toastr.error(
        t("reset_info_config_click_house_error_not_setting_default"),
      );
      e.handled = true;
    } else if (e?.code === 404 && e?.subCode === 1200) {
      toastr.error(t("reset_info_config_click_house_error_record"));
      e.handled = true;
    }
    throw e;
  }
};

export const fetchInfoConfigThreshGeneralAsync = async (type_config) => {
  mushroom.info_config_thresh_general.invalidCache();
  const { result } = await mushroom.info_config_thresh_general.getAllAsync({
    fields: Project.include(
      "type",
      "name",
      "value",
      "value_unit",
      "note",
      "enable",
      "min_value",
      "max_value",
      "description",
    ).build(),
    filters: Filter.eq("type", type_config).build(),
  });
  return result;
};

export const updateInfoConfigThreshGeneralAsync = async (
  info_config_thresh_general_object,
) => {
  try {
    const { result } =
      await mushroom.info_config_thresh_general.partialUpdateAsync(
        info_config_thresh_general_object,
      );
    return result;
  } catch (error) {
    toastr.error(t("toastr_error"));
    throw error;
  }
};

export const resetInfoConfigThreshGeneralAsync = async (idClickhouse) => {
  try {
    const { result } =
      await mushroom.info_config_thresh_general.resetToDefaultAsync({
        body: {
          id: idClickhouse,
        },
      });
    return result;
  } catch (e) {
    if (e?.code === 400 && e?.subCode === 1000) {
      toastr.error(t("reset_info_config_click_house_error_id"));
      e.handled = true;
    } else if (e?.code === 400 && e?.subCode === 1001) {
      toastr.error(
        t("reset_info_config_click_house_error_not_setting_default"),
      );
      e.handled = true;
    } else if (e?.code === 404 && e?.subCode === 1200) {
      toastr.error(t("reset_info_config_click_house_error_record"));
      e.handled = true;
    }
    throw e;
  }
};

export const fetchQoeWeightConfigAsync = async (limit, offset) => {
  mushroom.info_config_service_weight.invalidCache();
  const { result } =
    await mushroom.info_config_service_weight.views.getQoeWeightConfigAsync({
      _limit: limit,
      _offset: offset,
    });
  return result;
};

export const updateQoeWeightConfigAsync = async (
  info_config_thresh_general_object,
) => {
  try {
    const { result } =
      await mushroom.info_config_service_weight.partialUpdateAsync(
        info_config_thresh_general_object,
      );
    return result;
  } catch (error) {
    if (error.code === 404 && error.subCode === 1200) {
      toastr.error(t("t_clickhouse_qoe_weight_config_not_found_service_id"));
    } else {
      toastr.error(t("toastr_error"));
    }
    console.error("Error updating QOE weight config:", error);
    throw error;
  }
};

export const resetQoeWeightConfigAsync = async (idClickhouse) => {
  try {
    const { result } =
      await mushroom.info_config_service_weight.resetToDefaultAsync({
        body: {
          id: idClickhouse,
        },
      });
    return result;
  } catch (e) {
    if (e?.code === 400 && e?.subCode === 1000) {
      toastr.error(t("reset_info_config_click_house_error_id"));
      e.handled = true;
    } else if (e?.code === 400 && e?.subCode === 1001) {
      toastr.error(
        t("reset_info_config_click_house_error_not_setting_default"),
      );
      e.handled = true;
    } else if (e?.code === 404 && e?.subCode === 1200) {
      toastr.error(t("reset_info_config_click_house_error_record"));
      e.handled = true;
    }
    throw e;
  }
};
